<template>
	<router-view />
</template>

<script>
import globalProperties from "@/api/globalProperties.js";
import { provide, ref } from "@vue/runtime-core";
import * as echarts from "echarts";
import { apiUserRoleInfo } from "@/api/requestApis.js";
export default {
	setup() {
		const { userType, orderStatus } = globalProperties;
		const courierCompanyList = [
			{ value: "yuantong", label: "圆通速递" },
			{ value: "yunda", label: "韵达快递" },
			{ value: "zhongtong", label: "中通快递" },
			{ value: "shentong", label: "申通快递" },
			{ value: "youzhengguonei", label: "邮政快递包" },
			{ value: "huitongkuaidi", label: "百世快递" },
			{ value: "shunfeng", label: "顺丰速运" },
			{ value: "ems", label: "EMS" },
			{ value: "jtexpress", label: "极兔速递" },
			{ value: "jd", label: "京东物流" },
			{ value: "youzhengbk", label: "邮政标准快" },
			{ value: "debangwuliu", label: "德邦" },
			{ value: "debangkuaidi", label: "德邦快递" },
			{ value: "yuantongkuaiyun", label: "圆通快运" },
			{ value: "youshuwuliu", label: "优速快递" },
			{ value: "zhaijisong", label: "宅急送" },
			{ value: "baishiwuliu", label: "百世快运" },
			{ value: "zhongtongkuaiyun", label: "中通快运" },
			{ value: "yundakuaiyun", label: "韵达快运" },
			{ value: "zhongtongguoji", label: "中通国际" },
			{ value: "shansong", label: "闪" },
		];
		let roleList = ref([]);
		const getRoleList = async () => {
			if (roleList.value.length) {
				return Promise.resolve(roleList);
			} else {
				const res = await apiUserRoleInfo();
				roleList.value = (res && res.records) || [];
			}
		};
		getRoleList();
		provide("roleList", roleList);
		provide("userTypeInfo", userType);
		provide("echarts", echarts);
		provide("orderStatus", orderStatus);
		provide("courierCompanyList", courierCompanyList);
		return {};
	},
};
</script>


